import { ProductActivitiesLine } from 'Components/lines/product-activities-line/ProductActivitiesLine';
export default ProductActivitiesLine;
